import { createAction, handleActions } from 'redux-actions';

const setLoading = createAction("MODALS/ORDER/SET_LOADING");

const defaultState = true;

const reducer = handleActions(
  {
    [setLoading]: (state, action) => action.payload
  },
  defaultState
);

export { setLoading, reducer };
